import { render, staticRenderFns } from "./TabDossierSalesInvoices.vue?vue&type=template&id=2de2de11"
import script from "./TabDossierSalesInvoices.vue?vue&type=script&setup=true&lang=js"
export * from "./TabDossierSalesInvoices.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports